import axios from 'axios';
import queryString from '../../utils/queryString';
import { headers, salesServiceUrl } from '../../config';

export function getCreditNote(id) {
    return axios.get(`${salesServiceUrl}/credit-notes/${id}`, { headers: headers() });
}

export function getCreditNotesList(payload) {
    let query = queryString(payload);
    return axios.get(`${salesServiceUrl}/credit-notes?${query}`, { headers: headers() });
}

export function simulateCreditNote({creditNoteId}) {
    return axios.get(`${salesServiceUrl}/credit-notes/${creditNoteId}/simulate`, { headers: headers() });
}

export function postCreditNote({creditNoteId, dpk}) {
    return axios.post(`${salesServiceUrl}/credit-notes/${creditNoteId}/post`, {}, { headers: {...headers(), Dpk: dpk } });
}

export function deleteCreditNote(id) {
    return axios.delete(`${salesServiceUrl}/credit-notes/${id}`, { headers: headers() });
}